import { Component } from '@angular/core';
import { IzzyChannelMessageNoteEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Channel Message Notes') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzychannelmessagenote-form',
    templateUrl: './izzychannelmessagenote.form.component.html'
})
export class IzzyChannelMessageNoteFormComponent extends BaseFormComponent {
    public record!: IzzyChannelMessageNoteEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'relationships', sectionName: 'Relationships', isExpanded: true },
            { sectionKey: 'noteContent', sectionName: 'Note Content', isExpanded: true },
            { sectionKey: 'authorInformation', sectionName: 'Author Information', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

